export const getConfig = () => {
  const name = import.meta.env.VITE_ENVIRONMENT || "dev";
  const authTenantId =
    import.meta.env.VITE_AUTH_TENANT_ID ||
    "c5546184-c827-45e1-bdca-78353c329c48";
  const authClientAppId =
    import.meta.env.VITE_AUTH_CLIENT_APPID ||
    "49b9c5d8-9d7a-454e-891d-fd374dad1178";
  const authServerAppId =
    import.meta.env.VITE_AUTH_SERVER_APPID ||
    "55cc6bd1-d502-4840-b22d-1a6c489fc92a";
  const mtmBaseUrl =
    import.meta.env.VITE_MTM_BASE_URL || "https://dev.mtm.app.medi.de/api";
  const mtmAuthServerAppId =
    import.meta.env.VITE_MTM_AUTH_SERVER_APPID ||
    "f46a5923-4048-4efc-9bcb-96b2fcb2bbbf";

  let backendUrl = "";
  switch (import.meta.env.VITE_ENVIRONMENT) {
    case "prod":
      backendUrl = "https://prod.mds.app.medi.de";
      break;
    case "stage":
      backendUrl = "https://stage.mds.app.medi.de";
      break;
    case "dev":
      backendUrl = "https://dev.mds.app.medi.de";
      break;
    default:
      backendUrl = "https://localhost:5201";
      break;
  }

  return {
    name: name,
    authTenantId: authTenantId,
    authClientAppId: authClientAppId,
    authServerAppId: authServerAppId,
    httpTimeoutMs: 300000,
    backendUrl: backendUrl,
    apiUrl: "mdsapi",
    mtmService: {
      baseUrl: mtmBaseUrl,
      authServerAppId: mtmAuthServerAppId,
    },
  };
};

export const getConfigName = (): "local" | "dev" | "stage" | "prod" => {
  switch (import.meta.env.VITE_ENVIRONMENT) {
    case "prod":
      return "prod";
    case "stage":
      return "stage";
    case "dev":
      return "dev";
    default:
      return "local";
  }
};
